export type ListOfErrors = Array<string | null | undefined> | null | undefined

export function ErrorList({
	id,
	errors,
}: {
	errors?: ListOfErrors
	id?: string
}) {
	const errorsToRender = errors?.filter(Boolean)
	return (
		<ul id={id} className="flex min-h-[1rem] flex-col gap-1">
			{errorsToRender?.map((e) => (
				<li key={e} className="text-[10px] text-danger-text">
					{e}
				</li>
			))}
		</ul>
	)
}
